import C from "../constants";

export default {
  getUser: function (userId) {
    return {
      types: [C.GET_USER, C.GET_USER_SUCCESS, C.GET_USER_FAIL],
      promise: (client) =>
        client.get(`/api/users/${userId}`).then((response) => {
          return response;
        }),
    };
  },

  getDocumentsOwners: function () {
    return {
      types: [
        C.GET_DOCUMENT_OWNERS_LIST,
        C.GET_DOCUMENT_OWNERS_LIST_SUCCESS,
        C.GET_DOCUMENT_OWNERS_LIST_FAIL,
      ],
      promise: (client) =>
        client.get(`/api/documents-owners`).then((response) => {
          return response;
        }),
    };
  },

  getDocumentsClients: function () {
    return {
      types: [
        C.GET_DOCUMENT_CLIENTS_LIST,
        C.GET_DOCUMENT_CLIENTS_LIST_SUCCESS,
        C.GET_DOCUMENT_CLIENTS_LIST_FAIL,
      ],
      promise: (client) =>
        client.get(`/api/documents-clients`).then((response) => {
          return response;
        }),
    };
  },
};
